import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ProductSearch from './components/ProductSearch';
import CatalogueSearch from './components/CatalogueSearch';
import Inventory from './components/Inventory';
import Login from './components/Login';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authData, setAuthData] = useState(null);

  useEffect(() => {
    // Check if user is already authenticated
    const savedPhone = localStorage.getItem('authPhone');
    const savedOTP = localStorage.getItem('authOTP');
    
    if (savedPhone && savedOTP) {
      setAuthData({ phone: savedPhone, otp: savedOTP });
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (phone, otp) => {
    setAuthData({ phone, otp });
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authPhone');
    localStorage.removeItem('authOTP');
    setAuthData(null);
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div className="app">
        <Navbar onLogout={handleLogout} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<ProductSearch authData={authData} />} />
            <Route path="/catalogue" element={<CatalogueSearch authData={authData} />} />
            <Route path="/inventory" element={<Inventory authData={authData} />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App; 